<section class="main">
    <form #ngForm="ngForm">
        <div
            *ngFor="let question of selectedQuestions"
            [ngModelGroup]="question.field"
        >
            <consultation-question
                [question]="question"
                [data]="data[question.field]"
                [brand]="brand"
                [allAnswers]="data"
            ></consultation-question>
        </div>
    </form>
</section>
